<template>
  <div id="participant-print-card" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-row v-if="!isPrinting">
            <el-col :span="24">
              <div class="registration-question">
                <div class="sub-title">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.cardDesign") }}</div>
                <el-select v-model="form.schemeID" :class="$inputError('schemeID', validationErrors)">
                  <el-option v-for="item in printSchemeList" :key="item.id" :value="item.id" :label="item.title"></el-option>
                </el-select>
                <span class="text-danger"> {{ $errorMessage("schemeID", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="isPrinting" :key="proggressKey">
            <el-col :span="24">
              <el-alert :show-icon="true" :closable="false" type="info">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.infoMsg") }}</el-alert>
            </el-col>

            <el-col :span="24" v-if="validationErrors.length > 0">
              <div v-for="(errors, index) in validationErrors" :key="index">
                <el-alert :show-icon="true" :closable="false" type="warning" class="mt-1">{{ errors.value }}</el-alert>
              </div>
            </el-col>

            <el-col :span="24" class="d-flex align-items-center justify-content-center mt-2 after-success">
              <el-progress type="circle" :percentage="parseFloat(percentage.toFixed(2))" :status="printEnd == true ? 'success' : null"></el-progress>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save(false)" :disabled="loading != false" :loading="loading == 'printCard'">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.print") }}</el-button>
        <el-button type="primary" @click="save(true)" :disabled="loading != false" :loading="loading == 'printCardCheckIn'">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.checkAndPrint") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["participantIds"],
  data() {
    return {
      proggressKey: +new Date(),
      interval: null,
      loading: false,
      printCounter: 0,
      printEnd: false,
      isPrinting: false,
      percentage: 0,
      timeout: null,
      validationErrors: [],
      form: {
        id: null,
        schemeID: null,
        reason: "Toplu Kart Baskı",
        checkIn: true
      }
    };
  },
  computed: {
    printSchemeList() {
      return this.$store.state.printschemes.items.map(x => {
        return { id: x.id, title: x.title };
      });
    }
  },
  methods: {
    addBaseReason(text) {
      this.form.reason = text;
    },

    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async save(checkIn = false) {
      this.validationErrors = [];
      this.percentage = 0;
      this.printCounter = 0;
      this.printEnd = false;
      this.proggressKey += 1;
      if (!checkIn) {
        this.loading = "printCard";
      } else {
        this.loading = "printCardCheckIn";
      }

      this.form.id = this.participantId;
      this.form.checkIn = checkIn;

      if (this.participantIds.length == 0) {
        this.$message.info($t("participantManagament.registrationSearch.detailsParticipant.printCardComp.moreThanOne"));
        return;
      }

      this.isPrinting = true;

      for (var i = 0; i < this.participantIds.length; i++) {
        this.form.id = this.participantIds[i];

        var res = await this.$store.dispatch("participantPrintCard", this.form);
        if (res.data.alert.hasError) {
          this.validationErrors.push({ key: this.participantIds[i], value: res.data.alert.message });
        }

        this.printCounter += 1;
        this.percentage = (this.printCounter * 100) / this.participantIds.length;
        await this.sleep(1500);
      }
      // var res = await this.$store.dispatch('participantPrintCard', this.form)
      // this.validationErrors = res.data.validationErrors;
      // var res = await this.$store.dispatch('participantPrintCard', this.form)
      // this.validationErrors = res.data.validationErrors
      // if (!res.data.alert.hasError) {
      // 	this.$store.commit('setPrintSchemeId', this.form.schemeID)
      // 	this.$emit('refresh')
      // 	this.$emit('closeDialog')
      // }
      this.printEnd = true;
      this.loading = false;
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    var fIndex = this.printSchemeList.findIndex(x => x.id == this.$store.state.participants.selectedPrintSchemeID);
    if (fIndex != -1) {
      this.form.schemeID = this.$store.state.participants.selectedPrintSchemeID;
    } else {
      this.$store.state.participants.selectedPrintSchemeID = null;
    }
    await this.$store.dispatch("getPrintSchemes");
    this.loading = false;
  }
};
</script>

<style>
.after-success .el-icon-check
{
	font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/participants/BulkCardPrint.vue